import { Component, OnInit, HostListener, ViewChild, Input, ElementRef } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from '../../@theme/pipes/dateFormatPicker';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';


@Component({
  selector: 'ngx-foros-mensajes',
  templateUrl: './foros-mensajes.component.html',
  styleUrls: ['./foros-mensajes.component.scss'],
  providers: [UtilidadesService, PeticionesHttpBackEndService, NgbModalConfig, NgbModal, { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }]
})
export class ForosMensajesComponent implements OnInit {

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    placeholder: 'Nuevo comentario...',
    translate: 'no',
    sanitize: false,
    toolbarPosition: 'top',
    defaultFontName: 'Arial',
    height: '18rem',
    minHeight: '5rem',
  };
  Token: any;
  openModal: any;
  listadoTemas: any;
  usuario: any;
  tema: any;
  filtrarLista: any;
  listadoTemasFiltrado: any;
  nuevoMensaje: any;
  mostrarMensaje: boolean;
  imagenUser: any;
  temaId: any;
  listForosMensajes: any;
  mensajeCita: any;
  citaHtml: any;
  extensionSocial: any;
  foros: any;
  forosTemas: any;
  mostrarAvatar:boolean;
  msgError:boolean;
  lectura:boolean;
  escritura:boolean;
  busquedaActivada:boolean;
  busquedaGeneral:any;
  @ViewChild('divMensaje') divMensajeElement;
  foroId: any;
  constructor(private datepip: DatePipe, private _route: ActivatedRoute, private utilidades: UtilidadesService, config: NgbModalConfig, private modalService: NgbModal, private _http: PeticionesHttpBackEndService, private DatePipe: DatePipe, public fb: FormBuilder, private router: Router) {
    this.Token = JSON.parse(localStorage.getItem('auth_app_token'));
    this._route.queryParams.subscribe(params => {
      this.temaId = params.tema;
      this.foroId = params.f;
    });
    this.listadoTemas = [];
    this.listadoTemasFiltrado = [];
    config.backdrop = 'static';
    config.keyboard = false;
    this.mostrarMensaje = false;
    this.extensionSocial = null;
    this.foros = null;
    this.forosTemas = null;
    this.nuevoMensaje = "";
    this.mostrarAvatar = true;
    this.msgError = false;
    this.lectura = false;
    this.escritura = false;
    this.busquedaActivada = false;
    this.busquedaGeneral = "";

  }

  ngOnInit() {
    this.recuperarMensajes();

  }
  recuperarMensajes(){
    this._http.getUsuario().subscribe(
      result => {
        this.usuario = result;
        this._http.getOneReg("v1/getMensajes", this.usuario.Entidad._entidad_id + "/" + this.temaId + "/" + this.foroId).subscribe(
          result => {
            let resultado: any = result;
            

          if(resultado.Code == 250){
              this.msgError = true;
              this.utilidades.notificationWarning("Aviso","Debe aceptar los terminos LOPD de su pestaña social","top-left");
          }else{
            this.msgError = false;
              this.foros = JSON.parse(JSON.stringify(resultado.Foros))
            this.forosTemas = JSON.parse(JSON.stringify(resultado.ForosTemas))
            this.listForosMensajes = JSON.parse(JSON.stringify(resultado.ForosMensajes));
            this.extensionSocial = resultado.ExtSocial !== null && resultado.ExtSocial !== undefined ? JSON.parse(JSON.stringify(resultado.ExtSocial)) : null;
            this.mostrarAvatar = this.extensionSocial !== null && this.extensionSocial._imagen_u_r_l !== null && this.extensionSocial._imagen_u_r_l !== undefined && this.extensionSocial._imagen_u_r_l !== "" ? false : true;
            this.mostrarMensaje = true;
            this.lectura = resultado.lectura;
            this.escritura = resultado.escritura;           
            }
          });
      }
    );
  }
  showMensaje() {
    setTimeout(() => {
      this.scroll(this.divMensajeElement.nativeElement);
    }, 0);


  }
  /**
  * Función para hacer scroll en la página
  * @param el Elemento
  */
  scroll(el: HTMLElement) {

    el.scrollIntoView(false);



  }

  citarMensaje(mensaje) {

    this.mensajeCita = mensaje;
    if (mensaje._mencion_mensaje_id !== null && mensaje._mencion_mensaje_id !== undefined) {
      let apellidos = mensaje._mencion_mensaje_id._entidad_creadora_id._apellidos !== undefined ? mensaje._mencion_mensaje_id._entidad_creadora_id._apellidos : "";
      this.nuevoMensaje = "<blockquote><div #cit style='border: 1px solid black;background-color: rgba(165, 165, 165, 0.301);padding: 15px;margin-bottom: 10px'><div #cit style='border: 1px solid black;background-color: rgba(165, 165, 165, 0.301);padding: 15px;margin-bottom: 10px'><p><strong>" + mensaje._mencion_mensaje_id._entidad_creadora_id._nombre + " " + apellidos + " dijo: </strong></p><span>" + mensaje._mencion_mensaje_id._descripcion + " </span></div><br><br><p><strong>" + mensaje._entidad_creadora_id._nombre + " " + apellidos + " dijo: </strong></p><span>" + mensaje._descripcion + " </span></div></blockquote><br>"
      this.citaHtml = this.nuevoMensaje;

    } else {
      let apellidos = mensaje._entidad_creadora_id._apellidos !== undefined ? mensaje._entidad_creadora_id._apellidos : "";
      this.nuevoMensaje = "<blockquote><div #cit style='border: 1px solid black;background-color: rgba(165, 165, 165, 0.301);padding: 15px;margin-bottom: 10px'><p><strong>" + mensaje._entidad_creadora_id._nombre + " " + apellidos + " dijo: </strong></p><span>" + mensaje._descripcion + " </span></div></blockquote><br>"
      this.citaHtml = this.nuevoMensaje;
    }
    setTimeout(() => {
      this.scroll(this.divMensajeElement.nativeElement);
    }, 0);

    this.mostrarMensaje = true;

  }

  publicar() {    
    let mensajePublicar = "";
    if (this.mensajeCita !== null && this.nuevoMensaje.trim().indexOf("<div #cit") !== -1) {
      let a = this.mensajeCita._mencion_mensaje_id !== null && this.mensajeCita._mencion_mensaje_id !== undefined ? this.nuevoMensaje.trim().indexOf(this.mensajeCita._mencion_mensaje_id._descripcion) : 0;
      let b = this.nuevoMensaje.indexOf("</blockquote>");//this.nuevoMensaje.trim().indexOf(this.mensajeCita._descripcion);
      if (b !== -1) {//a !== -1 && 
        mensajePublicar = this.nuevoMensaje.substr(this.nuevoMensaje.indexOf("</blockquote>") + "</blockquote>".length);
      }
    } else {
      mensajePublicar = this.nuevoMensaje;
    }

    if (this.nuevoMensaje !== null && this.nuevoMensaje !== undefined && this.nuevoMensaje.length > 0) {

      this._http.insertaObjecto("v1/actualizarForoMensajes", {
        Data: {
          "entidadId": this.usuario.Entidad._entidad_id, "temaId": this.temaId, "comentario": mensajePublicar,
          "mensajeCita": this.mensajeCita == undefined ? null : this.mensajeCita
        }
      }).subscribe(
        result => {
          let resultado: any = result;
          if(resultado.Code == 200){
            this.listForosMensajes = JSON.parse(JSON.stringify(resultado.ListadoMensajes));
            this.nuevoMensaje = "";
            this.mensajeCita = null;
          }else{
            this.utilidades.notificationWarning("Aviso",resultado.mensaje,"top-left");
          }
    
        },
        error => {
        }
      );
    }else{
      this.utilidades.notificationWarning("Aviso","Debe escribir algun comentario antes de publicar","top-left");
    }
  }
  limpiarMensaje() {
    this.nuevoMensaje = "";
    this.mensajeCita = null;
  }

  buscar() {
    this.listadoTemasFiltrado = JSON.parse(JSON.stringify(this.listadoTemas))
    if (this.filtrarLista !== "") {
      this.listadoTemasFiltrado = [];
      this.listadoTemas.forEach(element => {
        if ((this.filtrar_acentos(element._nombre).indexOf(this.filtrar_acentos(this.filtrarLista)) !== -1) ||
          (this.filtrar_acentos(element._descripcion).indexOf(this.filtrar_acentos(this.filtrarLista)) !== -1)) {
          this.listadoTemasFiltrado.push(element);
        }
      });
    }
  }
  filtrar_acentos(input) {
    var acentos = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç";
    var original = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc";
    for (var i = 0; i < acentos.length; i++) {
      input = input.replace(acentos.charAt(i), original.charAt(i)).toLowerCase();
    };
    return input;
  }

  navegarForoPrincipal() {
    if(this.usuario.Entidad._rol_id !== 1){
      this.router.navigate(['private/user-foros']);
    }else{
      this.router.navigate(['private/admin-foros']);
    }
  }
  navegarForo(id) {
    let parametros: NavigationExtras = {
      queryParams: { 'foroId': id }
    };
  
    if(this.usuario.Entidad._rol_id !== 1){
      this.router.navigate(['private/user-subforos'], parametros);
    }else{
      this.router.navigate(['private/admin-subforos'], parametros);
    }
  }

  navegarTema(id) {
    let parametros: NavigationExtras = {
      queryParams: { 'foroId': id }
    };
    if(this.usuario.Entidad._rol_id !== 1){
      this.router.navigate(['private/user-temas'], parametros);
    }else{
      this.router.navigate(['private/admin-temas'], parametros);
    }
  }

  navegarPaginaUsuario(usuarioMuro){
    if(this.openModal !== undefined){
      this.openModal.close();
    }
    let parametros: NavigationExtras = {
      queryParams: { 'uM': usuarioMuro}
    };
    this.router.navigate(['private/muro-usuarios'],parametros);
  }

  buscarActivado(){
    this.busquedaActivada = !this.busquedaActivada;
  }
  
  onSearch(){
    let parametros: NavigationExtras = {
      queryParams: { 'nom': this.busquedaGeneral }
    };
    this.router.navigate(['private/buscador'], parametros);
  }
  
  eliminarMensaje(evento){
     this._http.insertaObjecto("v1/deleteForoMensaje", {
      Data: {
        "entidadId": this.usuario.Entidad._entidad_id, 
        "foroMensajeId": evento._foro_mensaje_id
      }
    }).subscribe(
      result => {
        let resultado: any = result;
        if(resultado.Code == 200){
          this.recuperarMensajes();
          this.utilidades.notificationSuccess("Exito",resultado.Mensaje,"top-left");

        }else{
          this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
        }
  
      },
      error => {
      }
    );
  }



}
